import {
    CREATE_USER_PRODUCT_MEMBERSHIP,
    CREATE_USER_PRODUCT_MEMBERSHIP_FAILURE,
    CREATE_USER_PRODUCT_MEMBERSHIP_SUCCESS,
} from 'store/actions/types';

export const createUserProductMembership = (payload) => {
    return {
        type: CREATE_USER_PRODUCT_MEMBERSHIP,
        payload,
    };
};

export const createUserProductMembershipFailure = (error) => {
    return {
        type: CREATE_USER_PRODUCT_MEMBERSHIP_FAILURE,
        error,
    };
};

export const createUserProductMembershipSuccess = (payload) => {
    return {
        type: CREATE_USER_PRODUCT_MEMBERSHIP_SUCCESS,
        payload,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/users/product-memberships/createUserProductMembership.js